export const PRICING_IDS = {
  sections: {
    plans: "pricing-plans",
    trust: "pricing-trust",
    compare: "pricing-compare",
    enterprise: "pricing-enterprise",
    faq: "pricing-faq",
    faqItem: (key: string) => `pricing-faq-${key}`,
  },
  header: {
    root: "pricing-header-root",
    desktopNav: "pricing-header-desktop-nav",
    desktopItem: (itemId: string) => `pricing-header-desktop-item-${itemId}`,
    desktopItemButton: (itemId: string) =>
      `pricing-header-desktop-item-button-${itemId}`,
    desktopDropdown: (itemId: string) =>
      `pricing-header-desktop-dropdown-${itemId}`,
    desktopDropdownList: (itemId: string) =>
      `pricing-header-desktop-dropdown-list-${itemId}`,
    desktopSubitem: (itemId: string, index: number) =>
      `pricing-header-desktop-subitem-${itemId}-${index}`,
    desktopSubitemLink: (itemId: string, index: number) =>
      `pricing-header-desktop-subitem-${itemId}-${index}-link`,
    desktopSubitemBox: (itemId: string, index: number) =>
      `pricing-header-desktop-subitem-${itemId}-${index}-box`,
    mobileItem: (itemId: string) => `pricing-header-mobile-item-${itemId}`,
    mobileItemTrigger: (itemId: string) =>
      `pricing-header-mobile-item-trigger-${itemId}`,
    mobileItemPanel: (itemId: string) =>
      `pricing-header-mobile-item-panel-${itemId}`,
    mobileItemList: (itemId: string) =>
      `pricing-header-mobile-item-list-${itemId}`,
    mobileSubitem: (itemId: string, index: number) =>
      `pricing-header-mobile-subitem-${itemId}-${index}`,
  },
} as const;
